export default __webpack_public_path__ + "static/media/pro_aim_player.988a03b8.png";